<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Restricciones de elementos</h4>
    <hr />

    <!-- Filtros -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label fw-bold">Prestador</label>
        <select class="form-select" v-model="idPrestador" @change="getDataPaginaTodos">
          <option :value="null" disabled>Seleccione un prestador</option>
          <option v-for="p in prestadores" :key="p.idPrestador" :value="p.idPrestador">
            {{ p.razonSocial }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label fw-bold">Servicio</label>
        <select class="form-select" v-model="idServicio" @change="getDataPaginaTodos">
          <option :value="null" disabled>Seleccione un servicio</option>
          <option v-for="s in servicios" :key="s.idServicio" :value="s.idServicio">
            {{ s.nombre }}
          </option>
        </select>
      </div>
    </div>

    <DataTable
      :data="restricciones"
      :columns="columnas"
      idField="idRestriccion"
      mensajeVacio="No hay elementos restringidos para el prestador y servicio seleccionados."
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="true"
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @delete="row => quitarRestriccion(row.idRestriccion)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- Buscar elementos -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Buscar</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchTextElemento"
                    placeholder="Código o nombre del elemento (mín. 3 caracteres)"
                    @input="buscarElementosDebounce"
                  />
                </div>
              </div>
            </div>

            <!-- Resultados -->
            <div class="table-responsive mb-3 tabla-elementos" style="max-height:240px;overflow-y:auto;position:relative">
              <table class="table table-sm table-hover align-middle">
                <thead class="table-light">
                  <tr>
                    <th style="width:40px"></th>
                    <th>Código</th>
                    <th>Nombre</th>
                    <th>Clase</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="elementos.length === 0">
                    <td colspan="4" class="text-center text-muted">Sin resultados</td>
                  </tr>
                  <tr
                    v-for="e in elementos"
                    :key="e.idElemento"
                    :class="{ 'table-secondary': yaRestringido(e.idElemento) }"
                  >
                    <td>
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :checked="estaSeleccionado(e.idElemento)"
                        :disabled="yaRestringido(e.idElemento)"
                        @change="toggleElemento(e)"
                      />
                    </td>
                    <td>{{ e.codigo }}</td>
                    <td>
                      {{ e.nombre }}
                      <span v-if="yaRestringido(e.idElemento)" class="badge bg-secondary ms-1">
                        ya restringido
                      </span>
                    </td>
                    <td>{{ e.clasElemNombre }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Seleccionados -->
            <div class="mb-3">
              <label class="form-label fw-bold">
                Seleccionados ({{ seleccionados.length }})
              </label>
              <div>
                <span
                  v-for="s in seleccionados"
                  :key="s.idElemento"
                  class="badge bg-primary me-1 mb-1"
                  style="font-weight:normal"
                >
                  {{ s.codigo }} - {{ s.nombre }}
                  <span
                    class="material-icons"
                    style="font-size:14px;vertical-align:middle;cursor:pointer"
                    @click="toggleElemento(s)"
                  >close</span>
                </span>
                <span v-if="seleccionados.length === 0" class="text-muted">
                  Ningún elemento seleccionado.
                </span>
              </div>
            </div>

            <!-- Motivo -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Motivo</label></div>
                <div class="col-10">
                  <textarea class="form-control" rows="2" v-model="motivo"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarRestricciones"
              :disabled="seleccionados.length === 0"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout    from "@/components/Layout.vue";
import Footer    from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import api       from "@/services/api";
import Swal      from "sweetalert2";
import * as $    from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      prestadores:        [],
      servicios:          [],
      restricciones:      [],
      elementos:          [],
      seleccionados:      [],
      idPrestador:        null,
      idServicio:         null,
      searchTextElemento: "",
      motivo:             "",
      titulo:             "",
      modalWindow:        true,
      idEmpresa:          0,
      idPerfil:           0,
      idUsuario:          null,
      timer:              null,
    };
  },
  computed: {
    columnas() {
      return [
        { label: "Código",  field: "elementoCodigo" },
        { label: "Elemento", field: "elementoNombre" },
        { label: "Motivo",  field: "motivo" },
      ];
    },
  },
  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.idPerfil  = Number(window.sessionStorage.getItem("idPerfil"));
    this.idUsuario = Number(window.sessionStorage.getItem("idUsuario")) || null;
    this.getPrestadores();
    this.getServicios();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    async getPrestadores() {
      try {
        const r = await api.get("/vwprestadors/idempresa/" + this.idEmpresa + "/servicios");
        this.prestadores = Array.isArray(r.data) ? r.data.filter(p => p.estado === 1) : [];
      } catch (e) {
        console.error("Error al cargar prestadores:", e);
      }
    },
    async getServicios() {
      try {
        const r = await api.get("/vwservicios");
        this.servicios = Array.isArray(r.data) ? r.data.filter(s => s.estado === 1) : [];
      } catch (e) {
        console.error("Error al cargar servicios:", e);
      }
    },
    getDataPaginaTodos() {
      if (!this.idPrestador || !this.idServicio) {
        this.restricciones = [];
        return;
      }
      api.get("/elementorestricciones/search", {
        params: { idprestador: this.idPrestador, idservicio: this.idServicio, search: "" },
      })
        .then(r => { this.restricciones = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar restricciones:", e));
    },

    // ── Modal ──────────────────────────────────────────────────────
    abrirModalCrear() {
      if (!this.idPrestador || !this.idServicio) {
        Swal.fire({
          icon: "warning",
          title: "Atención",
          text: "Seleccione un prestador y un servicio.",
        });
        return;
      }
      this.modalWindow        = true;
      this.titulo             = "Restringir elementos";
      this.elementos          = [];
      this.seleccionados      = [];
      this.searchTextElemento = "";
      this.motivo             = "";
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    buscarElementosDebounce() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.buscarElementos, 400);
    },
    async buscarElementos() {
      const texto = this.searchTextElemento.trim();
      if (texto.length < 3) {
        this.elementos = [];
        return;
      }
      try {
        const r = await api.get("/vwelementos/searchS3", { params: { search: texto } });
        this.elementos = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        console.error("Error al buscar elementos:", e);
      }
    },
    estaSeleccionado(idElemento) {
      return this.seleccionados.some(s => s.idElemento === idElemento);
    },
    yaRestringido(idElemento) {
      return this.restricciones.some(r => r.idElemento === idElemento);
    },
    toggleElemento(e) {
      const i = this.seleccionados.findIndex(s => s.idElemento === e.idElemento);
      if (i >= 0) {
        this.seleccionados.splice(i, 1);
      } else {
        this.seleccionados.push({ idElemento: e.idElemento, codigo: e.codigo, nombre: e.nombre });
      }
    },

    // ── Guardar / quitar ───────────────────────────────────────────
    async guardarRestricciones() {
      if (this.seleccionados.length === 0) return;
      try {
        await api.post("/elementorestricciones/bulk", {
          idPrestador: this.idPrestador,
          idServicio:  this.idServicio,
          idUsuario:   this.idUsuario,
          motivo:      this.motivo,
          idsElemento: this.seleccionados.map(s => s.idElemento),
        });
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Restricciones registradas exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async quitarRestriccion(idRestriccion) {
      const confirm = await Swal.fire({
        title: "¿Quitar restricción?",
        text: "El prestador podrá volver a utilizar este elemento en el servicio.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, quitar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        // Borrado lógico (estado = 0). Para borrado físico: api.delete("/elementorestricciones/" + idRestriccion)
        await api.put("/elementorestricciones/" + idRestriccion + "/estado", null, {
          params: { estado: 0 },
        });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo quitar la restricción." });
      }
    },
  },
};
</script>
<style scoped>
.tabla-elementos .form-check-input {
  position: static;
  margin: 0;
  float: none;
}

/* Opcional: encabezado fijo al desplazar */
.tabla-elementos thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>